module.exports = __webpack_public_path__ + "static/media/ImpactHeroTrophy.dc944878.jpg";